import cn from "classnames";
import { topVar, transitionDurationVar } from "./consts";
export var useClassName = function(param) {
    var nonStickyHeader = param.nonStickyHeader, shouldRetainOriginalPosition = param.shouldRetainOriginalPosition;
    return nonStickyHeader ? "relative z-12" : cn("transition-top sticky z-12", topVar.className, transitionDurationVar.className, shouldRetainOriginalPosition ? "ease-[cubic-bezier(0.1,0.7,0.6,1)]" : "ease-linear");
};
